import { motion } from "framer-motion";
import React from "react";
import { adds } from "../../assets";
import CTAsec from "../../components/CTAsec";
import TitlePages from "../../components/TitlePage";
import List from "./List";
import Teconlogias from "./Tecnologias";

const Servicios = ({ variants }) => {
  return (
    <>
      <motion.div
        className={"transition"}
        initial={{ x: 0 }}
        animate={{ x: "100%" }}
        exit={{ x: 0 }}
        transition={{
          transition: 3,
          type: "spring",
          stiffness: 200,
        }}
      />
      <div className="containerDiv">
        <TitlePages
          title={"Creamos productos digitales"}
          toptitle={"Servicios"}
          para={
            "Comenzando en la definición del producto a desarrollar, siguiendo con el diseño de la UX-UI, el desarrollo del software, su calidad asegurada hasta el mantenimiento."
          }
          variants={variants}
          expand
        />
        <img className="blur blurSer1" src={adds.blur1} alt="Blur" />
        <img className="blur blurSer2" src={adds.blur1} alt="Blur" />

        <List variants={variants} />
        <Teconlogias variants={variants} />
        <CTAsec href={"/contacto"} type="link" variants={variants} />
      </div>
    </>
  );
};

export default Servicios;
